export const INPUT_FIELD_PLACEHOLDER = {
  PREFIX: 'DR. Name (18 letters and spaces max.)',
  POSTFIX: 'Name’s (12 letters and spaces max.)',
  KEYS: [9, 13, 16, 17, 18, 20, 27, 33, 34, 35, 36, 37, 38, 39, 40, 45, 46],
};
